import { createUseStyles } from "react-jss";
import { colors } from "../../../../constants/colors";
import {breakpoints} from "../../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  filters: {
    margin: "32px 0 24px 0",
    display:"flex",
    justifyContent:"space-between",
    [`@media (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.xl}px)`]: {
      display:"flex",
      flexDirection: "column"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display:"flex",
      flexDirection: "column"
    },
  },
  filter: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
  },
  thisMonth: {
    extend: "filter",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
  },
  thisWeek: {
    extend: "filter",
    borderLeft: "none",
    borderRadius: "0",
    "&:hover": {
      borderLeft: "none"
    }
  },
  yesterday: {
    extend: "filter",
    borderRight: "none",
    borderRadius: "0",
    borderLeft: "none",
    "&:hover": {
      borderLeft: "none",
      borderRight: "none"
    }
  },
  today: {
    extend: "filter",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0"
  },
  active: {
    backgroundColor: colors.brightBlue
  },
  filterText:{
    display:"flex",
    flexDirection:"column",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom:"8px",
    },
    "& p":{
      marginBottom:"6px"
    },
    "& span": {
      color: theme.filterText.filterTextColor,
      fontWeight: "500",
      fontSize: theme.filterText.filterTextSize,
      lineHeight: "20px",
    }
  },
  filterButtons:{
    display:"flex",
    flexDirection:"row",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexDirection: "column"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid"
    },
  },
  button: {
    minHeight: "40px",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: "center"
    }
  },
  buttonContainer:{
    display:"flex",
    justifyContent:"flex-end",
    alignItems:"flex-end",
    height: "min-content",
    alignSelf: "end",
    cursor: "not-allowed",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom:"8px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      alignSelf: "start",
      marginTop: "16px",
      width: "100%",
      display: "block",
    },
    [`@media (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.xl}px)`]: {
      justifyContent:"flex-start",
      alignItems:"flex-start",
      alignSelf: "start",
      marginTop: "16px",
    },
  },
  airlines:{
    marginRight: "12px",
    height: "44px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: 0,
    }
  },
  downloadCsvLoadingState: {
    border: `${theme.buttons.disabled.border} !important`,
  },
  filterDates:{
    display: "flex",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginTop: "16px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid"
    },
  }
}));

export default styles;

export const customSelectStyles = {
  menu: base => ({
    ...base,
    width: "200px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    },
  }),
  control: base => ({
    ...base,
    height: "100%",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    },
    width: "200px",
    borderRadius: "8px",
    borderColor: colors.darkGrey,
    "&:hover": {
      borderColor: colors.darkGrey,
    },
    boxShadow: null,
    minHeight: '44px',
  }),

  dropdownIndicator: (base) => ({
    ...base,
    marginRight: "6px",
    color: colors.inactiveGrey,
    "&:hover": {
      color: colors.inactiveGrey
    }
  }),

};


